import React from "react";
import { v4 as uuidv4 } from "uuid";
import { ImageWrapper, Image, HiddenImage } from "./styles";

const RoundImage = ({ src, width, wrapperStyles = {}, imageStyles = {} }) => {
  const guid = uuidv4();
  const fallback = require("assets/images/broken-image-icon.svg");

  wrapperStyles = {
    ...wrapperStyles,
    width: width || 45,
    height: width || 45,
  };

  imageStyles = {
    ...imageStyles,
    width: width || 45,
    height: width || 45,
    backgroundImage: `url(${src || fallback})`,
  };

  return (
    <ImageWrapper style={wrapperStyles}>
      <Image id={guid} style={imageStyles}>
        <HiddenImage
          onErrorCapture={() =>
            (document.getElementById(
              guid
            ).style.backgroundImage = `url(${fallback})`)
          }
          src={src}
        />
      </Image>
    </ImageWrapper>
  );
};

export default RoundImage;
